<div class='notificator {{type}}' *ngIf="exists" [class.gone]="!display">
    <div class='icon {{type}}'></div>
    <span>{{message}}</span>
</div>